// extracted by mini-css-extract-plugin
module.exports = {"trigger":"AdvertiserDisclosure_trigger__VX4Qu","trigger-with-background":"AdvertiserDisclosure_trigger-with-background__2hU8N"};